var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box_title_area",attrs:{"id":_vm.anchorId}},[_c('h3',{staticClass:"service-title-b"},[_vm._t("default")],2),_vm._v(" "),_c('p',[_vm._t("sub-title")],2),_vm._v(" "),_vm._t("additional")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc806f90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mpn-base-components/MpnSectionTitle.vue
// module id = null
// module chunks = 